// @TODO WMG1-573: Delete this temporary constant file once we've finalized the scroll collapse behavior.

export const SEARCH_PARAM_KEY = 'header';
export const WHITELISTED_DOMAINS = ['localhost', 'dev.wmg1.dev'];

export const EASING_FUNCTIONS = [
  'ease',
  'ease-linear',
  'ease-in',
  'ease-out',
  'ease-in-out',
] as const;

export const TRANSITION_DURATIONS = [
  'duration-75',
  'duration-100',
  'duration-150',
  'duration-200',
  'duration-300',
  'duration-500',
  'duration-700',
  'duration-1000',
] as const;
